import { useGridForm } from "@qw/ui";
import { type FC, useMemo } from "react";
import { BulkActions, type BulkActionsMenuItem } from "@/components/bulk-actions";
import { useBatchDeleteDrafts } from "@/providers/use-batch-delete-drafts";

export const DraftsBulkActions: FC = () => {
  const { selectedRowIds } = useGridForm();
  const [batchDeleteDrafts, { loading: isBatchDeleteDraftsLoading }] = useBatchDeleteDrafts();

  const isLoading = isBatchDeleteDraftsLoading;

  const actions = useMemo(() => {
    const items: BulkActionsMenuItem[] = [
      {
        icon: "delete",
        label: "Discard drafts",
        onClick: () => batchDeleteDrafts(selectedRowIds),
      },
    ];

    return { items };
  }, [selectedRowIds, batchDeleteDrafts]);

  return <BulkActions actions={actions} isLoading={isLoading} />;
};
